import { useEffect, useState } from "react";
import { PATH_SALA_PRODUCTION } from "../../../const/PATH";
import { EventoSlug } from "../../utils/EventoSlug";
import TiltedCard from "../ui/TiltedCard";

const springValues = {
  damping: 30,
  stiffness: 100,
  mass: 2,
};

const Sala = ({
  data,
}) => {
  const [image, setImage] = useState(
    `${PATH_SALA_PRODUCTION}${data?.imagen_logo}`
  );

  const manejarError = () => {
    setImage("/assets/img/eventos/imageNotFound.svg");
  };

  useEffect(() => {
    if (data) {
      setImage(`${PATH_SALA_PRODUCTION}${data?.imagen_logo}`);
    }
  }, [data]);

  return (
    <a
      href={`/sala/${EventoSlug(data?.nombre, data?.id)}`}
      className="text-dark text-center d-flex flex-column align-items-center mb-4 p-3"
    >
      <TiltedCard
        imageSrc={image}
        altText=""
        captionText=""
        containerHeight={"250px"}
        containerWidth={"100%"}
        imageHeight={"250px"}
        imageWidth={"250px"}
        rotateAmplitude={12}
        scaleOnHover={1.2}
        showMobileWarning={false}
        showTooltip={true}
        displayOverlayContent={true}
        overlayContent={<p className="tilted-card-demo-text"></p>}
      />

      <p className="mt-2 mb-0 text-dark">
        <span className="Grifter text-dark fs-6">{data?.provincia}</span> |{" "}
        {data?.localidad}
      </p>
      <h3 className="fs-5">{data?.nombre}</h3>
    </a>
  );
};

export default Sala;
